const selectIsToggleRightSidenav =
  () =>
  ({ layout = {} }) =>
    layout.isToggleRightSidenav
const selectRightSideNavComponent =
  () =>
  ({ layout = {} }) =>
    layout.rightSideNavComponent
const selectHeaderTitle =
  () =>
  ({ layout = {} }) =>
    layout.headerTitle
const selectHeaderSubtitle =
  () =>
  ({ layout = {} }) =>
    layout.headerSubtitle

export {
  selectHeaderSubtitle,
  selectHeaderTitle,
  selectIsToggleRightSidenav,
  selectRightSideNavComponent,
}
